
        document.addEventListener('DOMContentLoaded', () => {
            // Back button handler to preserve map location
            const backButton = document.getElementById('back-button');
            if (backButton) {
                backButton.addEventListener('click', (e) => {
                    e.preventDefault();
                    const currentHash = window.location.hash;
                    window.location.href = '/' + currentHash;
                });
            }
        });
    